import { useLocation } from 'react-router-dom'

import { PlansGrid } from '@/components/Payment/PlansGrid'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import { useStripe } from '@/hooks/Stripe/useStripe'

interface LocationState {
  email?: string
  customerId?: string
  product?: string
}

export const PublicPaymentPaywall = () => {
  const location = useLocation()
  const state = location.state as LocationState

  const customerId = state?.customerId
  const email = state?.email
  const isImpersonation = state?.product === 'impersonation'

  const {
    pricingProducts,
    isLoadingPricing,
    isPricingSuccess,
    handleSelectPlan,
  } = useStripe({
    skipTopup: true,
    productType: isImpersonation ? 'impersonation' : undefined,
  })

  return (
    <WeScreen
      useHeader={false}
      isLoading={isLoadingPricing}
      customViewStyles="max-md:p-0"
    >
      {isPricingSuccess && (
        <div className="flex flex-col items-center w-full min-h-full relative">
          <div className="w-full flex justify-center py-6 lg:py-10">
            <div className="w-full max-w-5xl">
              <PlansGrid
                plans={pricingProducts}
                isLoading={isLoadingPricing}
                onSelectPlan={(product) =>
                  handleSelectPlan(product, {
                    customerId,
                    email,
                  })
                }
              />
            </div>
          </div>
        </div>
      )}
    </WeScreen>
  )
}
